"use client";

import { Button } from "@/components/catalyst/button";
import {
  Home,
  Map,
  FileText,
  Briefcase,
  Code,
  Settings,
  Mail,
  PenSquare,
  Atom,
  LayoutGrid,
} from "lucide-react";

export function SingularNavItem({
  tab,
  idx,
  isMobile,
}: {
  tab: any;
  idx: any;
  isMobile: any;
}) {
  // Map icon names to components
  const iconMap = {
    Home: Home,
    MapRoute: Map,
    Article: FileText,
    Briefcase: Briefcase,
    Code: Code,
    Tools: Settings,
    Mail: Mail,
    Writing: PenSquare,
    Atom2: Atom,
    Cards: LayoutGrid,
  };

  // Get the icon component from our map
  const IconComponent = iconMap[tab.metadata.icon];

  return (
    <Button
      key={idx}
      href={tab.metadata.slug}
      plain
      className={`group relative z-10 w-full hover:bg-neutral-100 focus:ring-0 focus:outline-none dark:hover:bg-neutral-600`}
    >
      {IconComponent ? (
        <div className="relative">
          <IconComponent className={`size-4`} />
        </div>
      ) : null}
      {!isMobile && <span>{tab.metadata.label}</span>}
    </Button>
  );
}
